<div [formGroup]="configFormGroup">
  <h2>Power Bi Config</h2>
  <div dwRow>
    <div dwCol="6">
      <label>WorkspaceId</label>

        <input type="text" formControlName="workspaceId" class="form-control">

    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>ReportId</label>

        <input type="text" formControlName="reportId" class="form-control">

    </div>
  </div>

  <div dwRow>
    <div dwCol="6">
      <label>Tables</label>
      <input type="text" formControlName="tableNames" class="form-control">
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Pass Grid Events</label>
      <input type='checkbox' formControlName="passGridEvents" class="form-control">
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Pass Grid Events</label>
      <input type='checkbox' formControlName="passUserId" class="form-control">
    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Height</label>
      <input type='number' formControlName="height" class="form-control">
    </div>
  </div>
</div>
